import React, { ReactElement } from "react";
import styled from "styled-components/macro";

const LogoDiv = styled.div`
	padding: 6.5px;
	font-size: 19px;
	font-weight: bold;
	text-align: left;
	letter-spacing: 1px;
	position: absolute;
	top: 6.5%;
	text-align: center;
	line-height: 2;
`;
const IntroGraphic = styled.img`
	max-width: 100%;
	max-height: 300px;
`;
function Logo(): ReactElement {
	return (
		<LogoDiv>
			<IntroGraphic src="logo_IK.png" />
			<br />
			By Lowe&#39;s Innovation Labs
		</LogoDiv>
	);
}

export default Logo;
